export class CsKeys {
  static backspace = 8;
  static tab = 9;
  static enter = 13;
  static esc = 27;
  static space = 32;
  static up = 38;
  static down = 40;
}
